import { render, staticRenderFns } from "./Empty.vue?vue&type=template&id=5c38d552&scoped=true&"
import script from "./Empty.vue?vue&type=script&lang=js&"
export * from "./Empty.vue?vue&type=script&lang=js&"
import style0 from "./Empty.vue?vue&type=style&index=0&id=5c38d552&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c38d552",
  null
  
)

export default component.exports